import { useMenuItems } from '@insurance/hooks'
import { useSessionContext } from '@shared/hooks'
import { AppNames } from '@shared/types'

import { lazy } from 'react'

const AppRouter = lazy(() => import('./AppRouter'))

export const useInsuranceConfig = () => {
  const menuItems = useMenuItems()
  const { broker } = useSessionContext()

  return {
    key: AppNames.Insurance,
    path: '/apps/insurance/:token/*',
    menu: menuItems,
    routes: <AppRouter />,
    forceToken: broker?.token
  }
}
